import { useState, useContext, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import CartContext from '../../store/cart-context';
import ShopContext from '../../store/shop-context';
import { toast } from 'react-toastify';
import { Modal } from 'react-bootstrap';
import Autocomplete from "react-google-autocomplete";

import Price from '../UI/Price';
import OrderSuccess from './OrderSuccess';

import classes from './styles/Order.module.css';
import { createOrder } from '../../api/main';

function ConfirmModal({ text, show, handleClose, handleCancel, handleOk }) {
  return (
    <Modal show={show} onHide={handleClose}>
      <Modal.Body>{text}</Modal.Body>
      <Modal.Footer>
        <button className='btn text-white btn-back' onClick={handleCancel}>No</button>
        <button className='btn text-white px-3' onClick={handleOk}>Si</button>
      </Modal.Footer>
    </Modal>
  );
}

function ChangeAddressModal({ show, handleClose, handleCancel }) {
  const shopContext = useContext(ShopContext);
  const [deliveryData, setDeliveryData] = useState(null);
  const [showOk, setShowOk] = useState(false);
  const [showNotAvailable, setShowNotAvailable] = useState(false);

  useEffect(() => {
    if( deliveryData ){
      const isDeliveryAvailable = isLatLngInBounds(deliveryData.location.lat, deliveryData.location.lng, shopContext.shop.delivery_area);

      if( !isDeliveryAvailable ){
        setShowOk(false);
        setShowNotAvailable(true);
      } else {
        setShowOk(true);
        setShowNotAvailable(false);
      }
    }
  }, [deliveryData]);

  const handleOk = () => {
    shopContext.setDeliveryData({ ...shopContext.delivery_data, ...deliveryData });
    handleClose();
    setShowOk(false);
  }

  const isLatLngInBounds = (lat, lng, bounds) => {
    return (lat >= bounds.south && lat <= bounds.north &&
            lng >= bounds.west && lng <= bounds.east);
  }

  const handlePlaceChange = async (place) => {
    setDeliveryData({
      formattedAddress: place.formatted_address,
      placeId: place.place_id,
      location: {
        lat: await place.geometry.location.lat(),
        lng: await place.geometry.location.lng(),
      }
    });
  }

  return (
    <Modal show={show} onHide={handleClose}>
      <Modal.Body>
        {showNotAvailable && (
          <p>Lamentablemente la direccion que ingresaste no esta disponible para delivery!</p>
        )}
        <p>Ingresa la NUEVA direccion de entrega:</p>
        <Autocomplete
          style={{ width: '100%' }}
          apiKey={"AIzaSyD20J9WRV9JmKy3ttSrcBxMGvJ6sNmXrSM"}
          options={{
            types: ["geocode"],
            componentRestrictions: { country: "ar" },
          }}
          language='es'
          onPlaceSelected={handlePlaceChange}
        />
      </Modal.Body>
      <Modal.Footer>
        <button className='btn text-white btn-back' onClick={handleCancel}>Cancelar</button>
        {showOk && (
          <button className='btn text-white px-3' onClick={handleOk}>Cambiar</button>
        )}
      </Modal.Footer>
    </Modal>
  );
}

const Order = () => {
  const navigate = useNavigate();
  const cartContext = useContext(CartContext);
  const shopContext = useContext(ShopContext);
  const [showSuccess, setShowSuccess] = useState(false);
  const [deliveryExtra, setDeliveryExtra] = useState('');
  const [paymentMethod, setPaymentMethod] = useState('transfer');
  const [orderTotal, setOrderTotal] = useState(0);
  const [itemToRemove, setItemToRemove] = useState(0);

  const [showAddressChange, setShowAddressChange] = useState(false);
  const [showConfirm, setShowConfirm] = useState(false);
  const [showConfirmRemove, setShowConfirmRemove] = useState(false);
  // const [confirmText, setConfirmText] = useState('');

  useEffect(() => {
    cartContext.setShowFooter(false);
  }, []);

  const handleRemoveItem = (index) => {
    setItemToRemove(index);
    setShowConfirmRemove(true);
  }

  const handleConfirmCloseRemove = () => {
    setItemToRemove(0);
    setShowConfirmRemove(false);
  }

  const handleConfirmationOkRemove = () => {
    cartContext.removeItem(itemToRemove);
    setItemToRemove(0);
    setShowConfirmRemove(false);
  }

  const handleConfirmClose = () => setShowConfirm(false);
  const handleConfirmationOk = async () => {
    // console.log(cartContext.items);
    setShowConfirm(false);
    const type_id = paymentMethod === 'transfer' ? 1 : 2;
    setOrderTotal(cartContext.totalAmount);
    const ret = await createOrder(cartContext.items, { ...shopContext.delivery_data, extra: deliveryExtra }, cartContext.totalAmount, type_id);
    if( ret ){
      cartContext.clear();
      setShowSuccess(true);
    }else
      toast.error("Ocurrio un error al generar el pedido! Por favor comunicate con nosotros al 11-7836-1122");
  }

  const handleAddressChangeClose = () => setShowAddressChange(false);

  const showOrderConfirmation = () => {
    // setConfirmText(
    //   <p>Estas seguro de confirmar tu pedido?<br />
    //   Metodo de pago: {paymentMethod === 'transfer' ? 'Transferencia' : 'Efectivo'}<br />
    //   Total: <Price value={cartContext.totalAmount} />
    //   </p>
    // );
    setShowConfirm(true);
  };

  const hideOrderSuccess = () => {
    setShowSuccess(false);
  };

  const handlePayment = (event) => {
    setPaymentMethod(event.target.value);
  };

  const havePromoItems = cartContext.items.filter(x => x?.promo || false).length > 0;

  return (
    <>
    <ChangeAddressModal 
      show={showAddressChange} 
      handleClose={handleAddressChangeClose} 
      handleCancel={handleAddressChangeClose} 
      />

    <ConfirmModal 
      text={<p>Estas seguro de confirmar tu pedido?<br />
      Metodo de pago: {paymentMethod === 'transfer' ? 'Transferencia' : 'Efectivo'}<br />
      Total: <Price value={cartContext.totalAmount} />
      </p>}
      show={showConfirm} 
      handleClose={handleConfirmClose} 
      handleCancel={handleConfirmClose} 
      handleOk={handleConfirmationOk}
      />

    <ConfirmModal 
      text={<p>Est&aacute;s seguro de eliminar el producto de tu pedido?<br />
      Se eliminar&aacute;n &eacute;ste y todos los productos relacionados a la promo.
      </p>}
      show={showConfirmRemove} 
      handleClose={handleConfirmCloseRemove} 
      handleCancel={handleConfirmCloseRemove} 
      handleOk={handleConfirmationOkRemove}
      />

    {showSuccess && <OrderSuccess onHide={hideOrderSuccess} paymentMethod={paymentMethod} orderTotal={orderTotal} />}

    <section className={classes.order}>

      <h5>Detalle del pedido</h5>

      <ul className={`${classes.orderItems}`}>
        {(!cartContext.items || cartContext.items.length <= 0) && (
          <li>No tenes productos agregados!</li>
        )}

        {cartContext.items && cartContext.items.map((x, xi) => x.products.map((v, i) => (
          <li key={i}>
            <button>
              <i className="fa-solid fa-trash-can" onClick={() => handleRemoveItem(xi)}></i>
            </button>
            {x.promo && (
              <><strong>Promo:</strong> {x.promo.name}<br /></>
            )}
            <strong>Formato:</strong> {v.name}<br />
            <strong>Gustos:</strong> {v.selectedSubItems.map(v => v.name).join(' - ')}<br />
            <div className='text-end'><Price value={v.price} /></div>
          </li>
        )))}
      </ul>

      <div className={classes.address}>
        <p><strong>Recibe: </strong>{shopContext.delivery_data.name}</p>
        <p><strong>Telefono: </strong>{shopContext.delivery_data.tel}</p>
        <p><strong>Direccion de entrega: </strong><br />
        {shopContext.delivery_data.formattedAddress} <a onClick={() => setShowAddressChange(true)} style={{ textDecoration: 'underline', cursor: 'pointer', color: '#3E8A95' }}>Cambiar</a></p>
        <p><strong>Piso/Depto: </strong>{shopContext.delivery_data.address2 || 'N/A'}</p>
        <p>
          <strong>Aclaracion: </strong><br />
          <textarea className='w-100' rows={2} onChange={(e) => setDeliveryExtra(e.target.value)} value={deliveryExtra} />
        </p>
      </div>

      <div className={classes.payment}>
        <strong>Forma de pago: </strong>
        <div className="form-check">
          <input 
            className={`form-check-input ${classes.paymentMethod}`}
            type="radio" 
            name="payment" 
            id="paymentTransfer" 
            value="transfer" 
            onChange={handlePayment} 
            checked={paymentMethod === 'transfer'}
            />
          <label className="form-check-label" htmlFor="paymentTransfer">
            Transferencia
          </label>
        </div>

        <div className="form-check">
          <input 
            className={`form-check-input ${classes.paymentMethod}`}
            type="radio" 
            name="payment" 
            id="paymentCash" 
            value="cash" 
            onChange={handlePayment} 
            checked={paymentMethod === 'cash'}
            />
          <label className="form-check-label" htmlFor="paymentCash">
            Efectivo
          </label>
        </div>

      </div>

      {!havePromoItems && (
        <div className={classes.total}>
          <span>Total</span>
          <span><Price value={cartContext.totalAmount} /></span>
        </div>
      )}

      {havePromoItems && (
        <>
          <div className={classes.total}>
            <span>Subtotal</span>
            <span><Price value={cartContext.items.reduce((curr, i) => curr + parseInt(i.price), 0)} /></span>
          </div>

          <div className={classes.discount}>
            <span>Descuento</span>
            <span>- <Price value={cartContext.items.reduce((curr, i) => curr + parseInt(i.discount), 0)} /></span>
          </div>

          <div className={classes.total}>
            <span>Total</span>
            <span><Price value={cartContext.totalAmount} /></span>
          </div>
        </>
      )}

      <div className='d-flex gap-1 flex-column'>
        {cartContext.totalAmount > 0 && (
          <button className='btn text-white w-100 mb-2 mx-0' onClick={showOrderConfirmation}>Generar pedido</button>
        )}
        <button className='btn text-white w-100 my-0 mx-0 btn-back' onClick={() => navigate(-1)}>Volver</button>
      </div>

    </section>
    </>
  );
};

export default Order;
